import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey, QuickKeyProps } from "../../../QuickKey";

export type CustomerQuickKeyProps = {} & QuickKeyProps;

export const CustomerQuickKey = React.forwardRef<any, CustomerQuickKeyProps>(
  ({ disabled: _disabled, ...props }, ref) => {
    const { sale } = useSaleControllerProvider();
    const { colors: Colors } = useTheme();
    const navigation = useNavigation<SellScreenProps["navigation"]>();

    const hasCustomer = Boolean(sale?.customer.id);
    const isRemoveCustomer = hasCustomer;
    const title = isRemoveCustomer ? "Remove Customer" : "Add Customer";
    const backgroundColor = isRemoveCustomer
      ? Colors.destructive
      : Colors.action;

    const onPress = useCallback(() => {
      if (!sale) return;
      if (isRemoveCustomer) {
        return sale?.removeCustomer().catch((e) => console.log(e));
      }
      navigation.navigate("ActionsRootScreen", {
        screen: "CustomerRootScreen",
        params: {
          screen: "CustomerListScreen",
        },
      });
    }, [sale, isRemoveCustomer]);

    const disabled =
      _disabled !== undefined
        ? _disabled
        : !sale || sale.isClosed || sale.isSale == false;

    return (
      <QuickKey
        ref={ref}
        disabled={disabled}
        label={title}
        onPress={onPress}
        iconPrimary={
          <AntDesign
            name="adduser"
            size={24}
            color={
              disabled
                ? Colors.white
                : isRemoveCustomer
                ? Colors.quickKeyDestructionText
                : Colors.quickKeyActionText
            }
          />
        }
        backgroundColor={backgroundColor}
        isDestructive={isRemoveCustomer}
        isAction={!isRemoveCustomer}
        {...props}
      />
    );
  }
);
